import { AppSettings } from "../../constants/AppSettings";
import { PaginatingTableBehaviorType } from "../../models/PaginatingTableBehaviorType";
import { FilterController } from "./FilterController";
import PaginatingTable from "../../customControls/PaginatingTable";

export class PaginatingTableController extends FilterController {
  private _behavior: PaginatingTableBehaviorType;
  protected _pagination = {
    skip: 0,
    take: AppSettings.tableItemsThreshold
  };

  protected buildRequestBody(filters: Record<string, unknown>) {
    return {
      ...filters,
      ...this._pagination
    };
  }

  public async applyFilters() {
    this._resetPagination();
    await super.applyFilters();
  }

  private _resetPagination() {
    this._pagination = {
      skip: 0,
      take: AppSettings.tableItemsThreshold
    };

    const table = this.byId("paginatingTable") as PaginatingTable | undefined;
    table?.resetPagination();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async onFetchBatch(oEvent: any) {
    this._behavior = oEvent.getParameter("behavior") as PaginatingTableBehaviorType;
    this._pagination = {
      skip: oEvent.getParameter("skip"),
      take: oEvent.getParameter("take")
    };

    await this._fetchPage();
  }

  private async _fetchPage() {
    await this.fetchData(this.getFiltersData());
  }

  protected async fetchData(filters: Record<string, unknown>) {
    if (this._behavior === "InfiniteScroll") {
      const model = this.getModel();
      const modelData = model.getData();
      const existing = Array.isArray(modelData) ? modelData : [];

      const response = await this.post(this.getDataEndpoint(), {
        body: this.buildRequestBody(filters)
      });

      model.setData([...existing, ...(response as unknown[])]);
      model.refresh(true);
    } else {
      await this.fetchModelPost(this.getDataEndpoint(), undefined, {
        body: this.buildRequestBody(filters)
      });
    }
  }
}
